import { Convert } from '@itus/ui.common'

export const consequenceLifeCycleState = {
  notDefined: 'notdefined',
  new: 'new',
  edit: null,
  removed: 'removed'
}
const validStates = [
  consequenceLifeCycleState.notDefined,
  consequenceLifeCycleState.new,
  consequenceLifeCycleState.edit,
  consequenceLifeCycleState.removed
]

export class ConsequenceModel {
  constructor(data) {
    data = data || {}
    this.id = Convert.toString(data.id, null)
    this.assetId = Convert.toString(data.assetId, null)
    this.twinId = Convert.toString(data.twinId, null)
    this.failureModeId = Convert.toString(data.failureModeId, null)
    this.value = Convert.toInteger(data.value, null)
    this.scale = Convert.toString(data.scale, 'dollars')
    this.description = Convert.toString(data.description, '')
    this.library = data.library
    this.lifeCycleState = Convert.toString(data.lifeCycleState, null)
    if (!validStates.includes(this.lifeCycleState)) {
      throw new Error('invalid life cycle state for consequence: ' + this.lifeCycleState)
    }
  }
}
export default { ConsequenceModel }
